"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _index = _interopRequireDefault(require("../../utils/index"));

var _lodash = _interopRequireDefault(require("lodash"));

var _proLayouts = require("pro-layouts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GalleryGroup =
/*#__PURE__*/
function () {
  function GalleryGroup(config) {
    this.uniqueId = _index["default"].generateUUID();
    this.isGalleryGroup = true;

    if (config.dto && config.dto.dto) {
      config.dto = config.dto.dto; //defence patch due to mis-use of item-core

      if (_index["default"].isDev()) {
        console.warn('Item core is created with already existing item core');
      }
    }

    this.dto = _lodash["default"].merge({}, config.dto);

    _lodash["default"].merge(this, config.dto);

    if (config.scheme) {
      this.processScheme(config.scheme);
    } else {
      this.processScheme(new _proLayouts.Group({
        dto: config.dto
      }).scheme);
    }

    if (config.items) {
      this.items = config.items;
    } else {
      console.warn('Pro Gallery created Gallery Group without items', config);
    }
  }

  var _proto = GalleryGroup.prototype;

  _proto.processScheme = function processScheme(scheme) {
    this.id = scheme.id;
    this.idx = scheme.idx;
    this.width = scheme.width;
    this.height = scheme.height;
    this.totalHeight = scheme.totalHeight;
    this.ratio = scheme.ratio;
    this.top = scheme.top;
    this.left = scheme.left;
    this.right = scheme.right;
    this.bottom = scheme.bottom;
    this.visible = scheme.visible;
    this.rendered = scheme.rendered;
    this.required = scheme.required;
  };

  _proto.renderProps = function renderProps(galleryConfig) {
    return {
      className: 'group',
      id: this.id,
      idx: this.idx,
      key: this.key,
      type: this.type,
      top: this.top,
      left: this.left,
      right: this.right,
      bottom: this.bottom,
      width: this.width,
      height: this.height,
      totalHeight: this.totalHeight,
      items: this.items,
      visible: this.visible,
      rendered: this.rendered,
      required: this.required,
      galleryConfig: galleryConfig
    };
  };

  _createClass(GalleryGroup, [{
    key: "key",
    get: function get() {
      return 'group_' + this.id;
    }
  }]);

  return GalleryGroup;
}();
/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */


var _default = GalleryGroup;
exports["default"] = _default;